import styled from "styled-components";

export const InputTextarea = styled.textarea`
  padding: 16px;
  font-size: 1.4rem;
  line-height: 150%;

  &::placeholder {
    color: ${(props) => props.theme.colors.inputPlaceholder};
    font-size: 1.3rem;
  }
`;
